import $ from 'jquery';

$.fn.shuffleChildren = function() {
	$.each(this.get(), (index, el) => {
		const $el = $(el);
		const $children = $el.children();
		const children = $children.get();

		children.sort(() => {
			return 0.5 - Math.random();
		});

		// Detach children (not remove or empty the container) to keep data & events
		$children.detach();
		$(children).appendTo($el);
	});
};

export default $;